var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.979,
    height: 22.833,
    viewBox: "0 0 24.979 22.833",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Love",
    d: "M19.413,3a7.314,7.314,0,0,0-5.169,2.146A7.314,7.314,0,1,0,3.894,15.484l10.35,10.35,10.35-10.35A7.314,7.314,0,0,0,19.413,3Zm3.45,10.764-8.619,8.619L5.626,13.764a4.879,4.879,0,1,1,6.9-6.9L14.244,8.6l1.719-1.719a5,5,0,0,1,6.9,0,4.876,4.876,0,0,1,0,6.9Z",
    transform: "translate(-1.755 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/Love.328d7e178d24c9dfe26fedc364363ce5.svg";
export { ForwardRef as ReactComponent };